var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87709 9.77541C9.82459 9.76791 9.75709 9.76791 9.69709 9.77541C8.37709 9.73041 7.32709 8.65042 7.32709 7.32292C7.32709 5.96542 8.42209 4.86292 9.78709 4.86292C11.1446 4.86292 12.2471 5.96542 12.2471 7.32292C12.2396 8.65042 11.1971 9.73041 9.87709 9.77541Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87709 9.77541C9.82459 9.76791 9.75709 9.76791 9.69709 9.77541C8.37709 9.73041 7.32709 8.65042 7.32709 7.32292C7.32709 5.96542 8.42209 4.86292 9.78709 4.86292C11.1446 4.86292 12.2471 5.96542 12.2471 7.32292C12.2396 8.65042 11.1971 9.73041 9.87709 9.77541Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8421 14.7255C13.5071 15.948 11.7371 16.6905 9.78712 16.6905C7.83712 16.6905 6.06712 15.948 4.73212 14.7255C4.80712 14.0205 5.25712 13.3305 6.05962 12.7905C8.11462 11.4255 11.4746 11.4255 13.5146 12.7905C14.3171 13.3305 14.7671 14.0205 14.8421 14.7255Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8421 14.7255C13.5071 15.948 11.7371 16.6905 9.78712 16.6905C7.83712 16.6905 6.06712 15.948 4.73212 14.7255C4.80712 14.0205 5.25712 13.3305 6.05962 12.7905C8.11462 11.4255 11.4746 11.4255 13.5146 12.7905C14.3171 13.3305 14.7671 14.0205 14.8421 14.7255Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78711 16.6904C13.9292 16.6904 17.2871 13.3326 17.2871 9.19043C17.2871 5.04829 13.9292 1.69043 9.78711 1.69043C5.64497 1.69043 2.28711 5.04829 2.28711 9.19043C2.28711 13.3326 5.64497 16.6904 9.78711 16.6904Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78711 16.6904C13.9292 16.6904 17.2871 13.3326 17.2871 9.19043C17.2871 5.04829 13.9292 1.69043 9.78711 1.69043C5.64497 1.69043 2.28711 5.04829 2.28711 9.19043C2.28711 13.3326 5.64497 16.6904 9.78711 16.6904Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.bed2160f8d39d4659d514d64a6df851c.svg";
export { ForwardRef as ReactComponent };